import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { validarCheckout } from "../api"; // función que vamos a crear
import toast from "react-hot-toast";
import { motion, AnimatePresence } from "framer-motion";

const PagoExitoso = () => {
  const navigate = useNavigate();
  const [validado, setValidado] = useState(false);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const checkout_id = urlParams.get("checkout_id");

    const validarPago = async () => {
      if (!checkout_id) {
        toast.dismiss();
        toast.error("ID de pago inválido");
        navigate("/");
        return;
      }

      try {
        const res = await validarCheckout(checkout_id);

        if (res.success) {
          setValidado(true);
        } else {
          toast.dismiss();
          toast.error(res.message || "El pago no fue confirmado.");
          navigate("/");
        }
      } catch (err) {
        console.error("❌ Error validando el pago:", err);
        toast.dismiss();
        toast.error("Ocurrió un error inesperado");
        navigate("/");
      }
    };

    validarPago();
  }, [navigate]);

  if (!validado) return null;

  return (
    <motion.div
	      initial={{ y: "100%", opacity: 0 }}
	      animate={{ y: 0, opacity: 1 }}
	      exit={{ y: "100%", opacity: 0 }}
	      transition={{ duration: 0.7, ease: "easeInOut" }}
    	>
    <div className="app-container" style={{ textAlign: "center", padding: 40 }}>
      <img src="/assets/images/success.svg" alt="Éxito" width={120} style={{ marginBottom: 20 }} />
      <h2>¡Pago exitoso!</h2>
      <p>Tu transacción fue completada correctamente.</p>

      <button className="subscription-button" onClick={() => navigate("/perfil")} style={{ marginTop: 30 }}>
        Ir a mi perfil
      </button>
    </div>
    </motion.div>
  );
};

export default PagoExitoso;